import { Nullable } from '../types'
import { Roster, transformRosterOnGet, transformRosterOnSave } from './roster'

export interface RosterTemplate extends Roster {
  templateName?: Nullable<string>
}

// Functions to apply transformations to RosterTemplate object
export const transformRosterTemplateOnGet = (
  rosterTemplate: RosterTemplate
): RosterTemplate => {
  const roster = transformRosterOnGet(rosterTemplate)

  return {
    templateName: rosterTemplate.templateName,
    ...roster,
  }
}

export const transformRosterTemplateOnSave = (
  rosterTemplate: RosterTemplate
): object => {
  const roster = transformRosterOnSave(rosterTemplate)

  return {
    templateName: rosterTemplate.templateName,
    ...roster,
  }
}
